export const ESCOPO_PADRAO_FORM_ID = "escopo-padrao-form";

export const TITULO_NOVO = "Novo escopo padrão";
export const TITULO_EDICAO = "Editar escopo padrão";
export const SALVAR_LABEL = "Salvar";
export const SALVAR_EDICAO_LABEL = "Salvar alterações";

export const TIPO_OBRA_LABEL = "Tipo de Obra";
export const EMBARCACAO_LABEL = "Embarcação";
export const GRUPO_LABEL = "Grupo";
export const SUBGRUPO_LABEL = "Subgrupo";
export const EQUIPAMENTO_LABEL = "Equipamento (tag)";
export const FABRICANTE_LABEL = "Fabricante";
export const MODELO_LABEL = "Modelo";
export const ESCOPO_LABEL = "Escopo de classe";
export const NOME_ESCOPO_LABEL = "Nome do escopo macro";
export const ANO_REFERENCIA_LABEL = "Ano de referência";
export const SELECIONE_PLACEHOLDER = "Selecione…";
export const PREENCHIDO_PELA_TAG_PLACEHOLDER = "Preenchido pela tag";
export const HORAS_PLACEHOLDER = "Ex.: 20.000";
export const CUSTO_PLACEHOLDER = "0,00";
export const ESCOPO_PLACEHOLDER = {
  CLASSE: "Ex.: Inspeção do leme",
  OUTROS: "Ex.: Guindaste principal - manutenção programada",
} as const;

export const SECAO_IDENTIFICACAO = "Identificação";
export const SECAO_CUSTO_POR_PERIODICIDADE = "Horas e custo padrão por periodicidade";
export const SECAO_CUSTO = "Custo padrão";

/** Texto de apoio do cadastro, um por visão (Figma 3.1, 3.1b e 3.1c); a edição não leva apoio. */
export const APOIO_POR_VISAO = {
  EQUIPAMENTOS:
    "Preencha só o que existir: componente sem valor fica sem custo padrão. Todo valor preenchido exige a moeda. O escopo passa a aparecer na lista do Tipo de Obra no Nova Obra.",
  CLASSE:
    "Especial alimenta o 101, Intermediária o 102 e Bottom Survey os dois. Componente sem valor fica sem custo padrão; todo valor preenchido exige a moeda.",
  OUTROS:
    "Grupo Outros: escopo em texto livre, sem equipamento nem horas. Componente sem valor fica sem custo padrão; todo valor preenchido exige a moeda. O escopo passa a aparecer na lista do Tipo de Obra no Nova Obra.",
} as const;
export const SEM_VALOR = "—";

export const HORAS_LABEL = "Horas de revisão";
export const SERVICOS_LABEL = "Custo de Serviços";
export const MATERIAIS_LABEL = "Custo de Materiais";
export const MOEDA_LABEL = "Moeda";
/** Só no nome acessível do seletor de moeda; o rótulo visível é "Moeda" nos dois (Figma 13381:694776). */
export const MOEDA_SERVICOS_QUALIFICADOR = "(Serviços)";
export const MOEDA_MATERIAIS_QUALIFICADOR = "(Materiais)";
export const TITULO_INTERMEDIARIA = "Intermediária";
export const TITULO_OVERHAUL = "Overhaul";

export const ESCOPO_MAX = 255;

export const MSG_TIPO_OBRIGATORIO = "Escolha o Tipo de Obra.";
export const MSG_EMBARCACAO_OBRIGATORIA = "Escolha a embarcação.";
export const MSG_GRUPO_OBRIGATORIO = "Escolha o grupo.";
export const MSG_EQUIPAMENTO_OBRIGATORIO = "Escolha o equipamento.";
export const MSG_ESCOPO_OBRIGATORIO = "Informe o escopo.";
export const MSG_EQUIPAMENTO_JA_EXISTE = "Esse equipamento já existe.";
export const MSG_ESCOPO_JA_EXISTE = "Esse escopo já existe.";
export const MSG_ESCOPO_LONGO = `O escopo aceita até ${ESCOPO_MAX} caracteres.`;
export const MSG_CUSTO_INVALIDO = "Informe um valor maior ou igual a zero.";
export const MSG_MOEDA_OBRIGATORIA = "Informe a moeda do valor.";
export const MSG_HORAS_INVALIDAS = "Informe horas inteiras maiores que zero.";

/** Texto do Figma 3.3: sempre aparece na edição, com a contagem de `uso`. */
export const avisoEdicao = (versao: string, escopos: number, obras: number): string =>
  `A alteração vale só para a versão ${versao}. Os ${escopos} escopos macro de ${obras} Obras que já usam este custo padrão mantêm os valores atuais; no FEL 0, dá para atualizar manualmente no escopo macro.`;
